import React, { useState } from 'react';
import { EULAModal } from '../../../components';
import { Typography } from '../../../components';

import './CopyrightTermsAndConditions.scss';

const { Text, Link } = Typography;

export const CopyrightTermsAndConditions = () => {
    const [isEulaModalVisible, setIsEulaModalVisible] = useState(false);

    return (
        <div className="copyright-terms-and-conditions">
            <Text className="small">
                © {new Date().getFullYear()} RiverMeadow Software, Inc. RiverMeadow |{' '}
                <Link onClick={() => setIsEulaModalVisible(true)} className="eula-link">
                    Terms and Conditions
                </Link>
            </Text>
            <EULAModal open={isEulaModalVisible} onCancel={() => setIsEulaModalVisible(false)} />
        </div>
    );
};
